export default __webpack_public_path__ + "static/media/Multivac.e23ac8a4.png";